import PropTypes from "prop-types";
import React from "react";
import {
  ApplePodcastIcon,
  DeezerIcon,
  FacebookIcon,
  GooglePlayIcon,
  IHeartRadioIcon,
  InstagramIcon,
  OvercastIcon,
  SoundCloudIcon,
  SpotifyIcon,
  SticherIcon,
  TwitterIcon,
  YouTubeIcon,
  SimplecastIcon,
  PandoraIcon,
  AmazonMusicIcon,
} from "../icons/socialMedia";
import * as palette from "../palette";

export default function SocialMediaInput({ defaultValues, onInsert }) {
  return (
    <div>
      <form
        onSubmit={event => {
          event.preventDefault();
          event.stopPropagation();

          const socialMedias = Object.keys(SocialMedias)
            .map(socialMedia => {
              return {
                socialMedia,
                url: (event.target.elements[`url[${socialMedia}]`].value || "").trim(),
              };
            })
            .filter(({ url }) => url !== "");

          onInsert({
            socialMedias,
          });
        }}
        css={{
          width: 300,
          padding: 8,
          display: "grid",
          gridRowGap: 8,
        }}
      >
        {Object.entries(SocialMedias).map(([key, { name }]) => {
          return (
            <div
              key={key}
              css={{
                display: "grid",
                alignItems: "center",
                gridTemplateColumns: "1fr 1fr",
              }}
            >
              <span>{name}</span>

              <input
                type="url"
                name={`url[${key}]`}
                placeholder="What's the URL?"
                defaultValue={defaultValues !== null ? defaultValues[key] : ""}
                css={{
                  margin: 0,
                  padding: 8,
                  border: `solid 1px ${palette.sealBlue}`,
                  borderRadius: 2,
                }}
              />
            </div>
          );
        })}

        <button
          type="submit"
          css={{
            margin: 0,
            padding: 8,
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
          }}
        >
          Submit
        </button>
      </form>
    </div>
  );
}

SocialMediaInput.propTypes = {
  onInsert: PropTypes.func.isRequired,
  defaultValues: PropTypes.shape({
    twitter: PropTypes.string,
    facebook: PropTypes.string,
    instagram: PropTypes.string,
    youtube: PropTypes.string,
    applePodcast: PropTypes.string,
    spotify: PropTypes.string,
    googlePlay: PropTypes.string,
    soundCloud: PropTypes.string,
    deezer: PropTypes.string,
    iHeartRadio: PropTypes.string,
    overcast: PropTypes.string,
    stitcher: PropTypes.string,
    simplecast: PropTypes.string,
  }),
};

SocialMediaInput.defaultProps = {
  defaultValues: null,
};

export const SocialMedias = {
  twitter: {
    name: "Twitter",
    icon: TwitterIcon,
    iconProps: {
      width: 32,
      height: 32,
    },
  },
  facebook: {
    name: "Facebook",
    icon: FacebookIcon,
    iconProps: {
      width: 32,
      height: 32,
    },
  },
  instagram: {
    name: "Instagram",
    icon: InstagramIcon,
    iconProps: {
      width: 32,
      height: 32,
    },
  },
  youtube: {
    name: "YouTube",
    icon: YouTubeIcon,
    iconProps: {
      width: 32,
      height: 32,
    },
  },
  applePodcast: {
    name: "Apple Podcast",
    icon: ApplePodcastIcon,
    iconProps: {
      width: 32,
      height: 32,
    },
  },
  spotify: {
    name: "Spotify",
    icon: SpotifyIcon,
    iconProps: {
      width: 32,
      height: 32,
    },
  },
  googlePlay: {
    name: "Google Play",
    icon: GooglePlayIcon,
    iconProps: {
      width: 32,
      height: 32,
    },
  },
  soundCloud: {
    name: "SoundCloud",
    icon: SoundCloudIcon,
    iconProps: {
      width: 32,
      height: 32,
    },
  },
  deezer: {
    name: "Deezer",
    icon: DeezerIcon,
    iconProps: {
      width: 32,
      height: 32,
    },
  },
  iHeartRadio: {
    name: "iHeartRadio",
    icon: IHeartRadioIcon,
    iconProps: {
      width: 32,
      height: 32,
    },
  },
  overcast: {
    name: "Overcast",
    icon: OvercastIcon,
    iconProps: {
      width: 32,
      height: 32,
    },
  },
  stitcher: {
    name: "Stitcher",
    icon: SticherIcon,
    iconProps: {
      width: 32,
      height: 32,
    },
  },
  simplecast: {
    name: "Simplecast",
    icon: SimplecastIcon,
    iconProps: {
      width: 32,
      height: 32,
    },
  },
  pandora: {
    name: "Pandora",
    icon: PandoraIcon,
    iconProps: {
      width: 32,
      height: 32,
    },
  },
  amazonmusic: {
    name: "Amazon Music",
    icon: AmazonMusicIcon,
    iconProps: {
      width: 32,
      height: 32,
    },
  },
};
